type SeparateAll = <T>(items: T[], separator: string) => (string | T)[];
export const separateAll: SeparateAll = <T>(items: T[], separator: string) => {
  const l = items.length;

  return items.reduce<(string | T)[]>((memo, item, i) => {
    memo.push(item);
    if (l > 1 && i < l - 1) {
      memo.push(separator);
    }

    return memo;
  }, []);
};
